import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes, UrlMatcher, UrlSegment } from '@angular/router';
import { NX_MODAL_SCROLL_STRATEGY_PROVIDER } from '@aposin/ng-aquila/modal';

import { InitFamilyService } from '#services/cve/initFamily.service';
import FeatureToggleService from '#services/featureToggle/featureToggle.service';

import { lineOfBusinessToggleGuard } from './line-of-business-toggle.guard';
import { lineOfBusinessValidationGuard } from './line-of-business-validation.guard';
import { linesOfBusiness } from './services/cve/VettingIteration';

const lineOfBusinessMatcher: UrlMatcher = (url: UrlSegment[]) =>
  url.length && linesOfBusiness.map((lob) => lob.toLowerCase()).includes(url[0].path)
    ? { consumed: [url[0]], posParams: { lineOfBusiness: url[0] } }
    : null;

const lobChildrenRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard-routing.module').then((m) => m.routes),
  },
  {
    path: 'customerjourney/escalation-response/:token',
    providers: [NX_MODAL_SCROLL_STRATEGY_PROVIDER, InitFamilyService],
    loadComponent: () =>
      import('./cve/pages/escalation-response/escalation-response.component').then(
        (m) => m.EscalationResponseComponent,
      ),
  },
  {
    path: 'customerjourney/:iterationId',
    loadChildren: () => import('./cve/cve-routing.module').then((m) => m.routes),
    canActivateChild: [lineOfBusinessValidationGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];

@Component({
  selector: 'kyc-empty-redirect',
  template: '',
})
export class EmptyRedirectComponent {}

function featureToggleInitGuard(route: ActivatedRouteSnapshot) {
  const featureToggleService = inject(FeatureToggleService);
  featureToggleService.loadFeatureToggles(route);
  return true;
}

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [featureToggleInitGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./cve/pages/select-lob/select-lob.component').then((m) => m.SelectLobComponent),
        canActivate: [lineOfBusinessToggleGuard],
      },
      {
        matcher: lineOfBusinessMatcher,
        children: lobChildrenRoutes,
      },
      {
        path: '**',
        pathMatch: 'full',
        canActivate: [lineOfBusinessToggleGuard],
        component: EmptyRedirectComponent,
      },
    ],
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
  initialNavigation: 'enabledBlocking',
  paramsInheritanceStrategy: 'always',
});
